<template>
  <UserList />
</template>

<script>
import UserList from '@/components/UserList'

export default {
  name: 'NewUsers',
  components: {
    UserList,
  }
}
</script>
